import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import usePageLoaded from '../../../hooks/usePageLoaded'

import TabLinks from '../../ui/tabLinks'
import WalletPoints from './WalletPoints'
import Button from '../../ui/button'

import { TabLink } from '../../../store/commonTypes'
import paths from '../../../paths'
import { createLocalizedPath } from '../../../utils/localizationHelpers'

interface Props {
    amountOfGifts?: number
}

const WalletTabs = ({ amountOfGifts = 0 }: Props) => {
    usePageLoaded()

    const [t] = useTranslation()
    const history = useHistory()

    const links: TabLink[] = [
        {
            label: t('Pending gifts'),
            path: paths.myWallet.path,
            amount: amountOfGifts
        },
        {
            label: t('History'),
            path: paths.myWalletHistory.path
        }
    ]

    const handleGoBuyTokens = () => {
        history.push({
            pathname: createLocalizedPath(paths.payment.path),
            search: `?tokens`
        })
    }

    return (
        <div className="walletTabsRow">
            <TabLinks links={links} />
            <div className="walletTabsRow">
                <WalletPoints />
                <Button label={t('Replenish')} onClick={handleGoBuyTokens} />
            </div>
        </div>
    )
}

export default WalletTabs
